<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>产品名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.name"
                placeholder="请输入产品名称"/>
      <b class="queryParamsStyle">产品编码：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.code"
                placeholder="请输入产品编码"/>
      <b class="queryParamsStyle">产品参数：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.cs"
                placeholder="请输入产品参数"/>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search">查询</i></el-button>
      <el-button type="primary" v-if="checkPrower('spxxgl') " @click="createdata" size="medium" round><i
          class="el-icon-circle-plus"></i>新建产品
      </el-button>
      <el-button type="primary" v-if="checkPrower('cpdc') " @click="batchExport" size="medium" round><i
          class="el-icon-download"></i>批量导出
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh">重置</i></el-button>
    </div>
    <el-table v-loading="loading"
              :data="tableData"
              ref="multipleTable"
              @selection-change="handleSelectionChange"
              :row-class-name="getRowClass"
              style="width: 100%">
      <!-- 多选列（单选+全选） -->
      <el-table-column
          type="selection"
          width="55"
          align="center"
      >
      </el-table-column>
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column
          label="产品名称"
          prop="name" align="center">
        <template slot-scope="scope">
          <div style="color: blue;float:left" @click="handleEdit(scope.row,0)">{{ scope.row.name ?? '' }}</div>
          <i style="float:left;padding:6px 0px 0px 5px" class="el-icon-document-copy" @click="copyText(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column
          label="产品编码"
          prop="code" align="center">

      </el-table-column>
      <el-table-column
          label="产品库存"
          prop="state" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.state ?? 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column
          align="center" label="操作" v-if="checkPrower('spxxgl') " width="200">

        <template slot-scope="scope">
          <el-button
              size="mini"
              v-if="checkPrower('spxxgl') "
              @click="handleEdit( scope.row,1)">
            <i class="el-icon-setting"></i>
            信息维护
          </el-button>
          <el-button
              size="mini"
              v-if="checkPrower('spxxgl') "
              type="danger"
              @click="deleterole(scope.$index, scope.row)"><i class="el-icon-delete"></i>删除
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <template>
      <div>
        <pagination
            id="companyListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>
    <el-dialog id="cdia" :title="selectTable.title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="selectTable" :rules="formRules" ref="selectForm">
        <el-form-item label="产品名称:" label-width="100px" prop="name">
          <el-input v-model="selectTable.name" :disabled="!isupdate" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="产品编码:" label-width="100px" prop="code">
          <el-input v-model="selectTable.code" :disabled="!isupdate" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否原材料:" label-width="100px" prop="isycl">
          <el-radio v-model="selectTable.isycl" :disabled="!isupdate" :label='0'>否</el-radio>
          <el-radio v-model="selectTable.isycl" :disabled="!isupdate" :label='1'>是</el-radio>
        </el-form-item>
        <el-form-item label="原材料名称:" label-width="100px" v-if="selectTable.isycl=='1'" prop="yname">
          <el-input v-model="selectTable.yname" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="原材料编码:" label-width="100px" v-if="selectTable.isycl=='1'" prop="ycode">
          <el-input v-model="selectTable.ycode" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="阈值:" label-width="100px" prop="yz">
          <el-input-number
              v-model="selectTable.yz"
              :min="1"
              :disabled="!isupdate"
              controls-position="right"
              :step="1"
          ></el-input-number>
          <span style="margin-left: 20%">单位:</span>
          <el-select v-model="selectTable.dw" :disabled="!isupdate" placeholder="请选择" @change="getList"
                     style="width: 110px;">
            <el-option
                label="块"
                value="块"
            ></el-option>
            <el-option
                label="台"
                value="台"
            ></el-option>
            <el-option
                label="套"
                value="套"
            ></el-option>
            <el-option
                label="件"
                value="件"
            ></el-option>
            <el-option
                label="项"
                value="项"
            ></el-option>
            <el-option
                label="个"
                value="个"
            ></el-option>
            <el-option
                label="支"
                value="支"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签:" label-width="100px">
          <el-tag v-if="isupdate"
                  v-for="tag in allTags"
                  :key="tag.id"
                  style="margin-left: 10px"
                  :closable="true"
                  :type="selectedNames.includes(tag.name) ? 'primary' : 'info'"
                  @click="toggleTag(tag)"
                  @close="deleteTag(tag)" ;
          >
            {{ tag.name }}
          </el-tag>
          <el-tag v-if="!isupdate"
                  v-for="tag in selectedTags"
                  :key="tag.id"
                  style="margin-left: 10px"
                  :type="selectedNames.includes(tag.name) ? 'primary' : 'info'"
          >
            {{ tag.name }}
          </el-tag>
          <el-button @click="openTitle" v-if="isupdate" style="margin-left: 10px">添加</el-button>
        </el-form-item>
        <el-form-item label="品牌:" label-width="100px" prop="pp">
          <el-input v-model="selectTable.pp" :disabled="!isupdate" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="参数:" label-width="100px">
          <el-input :disabled="!isupdate"
                    v-model="selectTable.cs"
                    type="textarea"
                    :maxlength="300"
                    show-word-limit
                    :rows="3"
                    placeholder="请输入内容，最多300字"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品照片:" label-width="100px">
          <div class="upload-wrapper">
            <!-- 有图片时显示预览 + 删除 -->
            <div v-if="selectTable.cppic" class="preview-box">
              <el-image
                  :src="selectTable.cppicurl"
                  fit="contain"
                  style="width: 180px; height: 180px; border: 1px solid #ddd; border-radius: 4px;"
              >
                <template #error>
                  <div class="image-slot">
                    加载失败
                  </div>
                </template>
              </el-image>

              <el-button
                  v-if="isupdate"
                  type="danger"
                  size="small"
                  circle
                  style="position:absolute"
                  class="delete-btn"
                  @click="handleRemoveImage"
              >
                <i class="el-icon-delete"></i>
              </el-button>
            </div>

            <!-- 没图片时显示上传按钮 -->
            <el-upload
                v-if="!selectTable.cppic && isupdate"
                class="upload-demo"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                accept="image/jpeg, image/png, image/gif"
                :on-change="handleAvatarChange"
            >
              <el-button type="primary" plain size="small">
                <el-icon>
                  <Upload/>
                </el-icon>
                上传产品照片
              </el-button>
              <template #tip>
                <div class="el-upload__tip">
                  只能上传 jpg/png/gif 文件，且不超过 5MB
                </div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="产品手册:" label-width="100px">
          <div class="upload-wrapper">
            <!-- 有图片时显示预览 + 删除 -->
            <div v-if="selectTable.cpsc" class="preview-box">
              <a :href="selectTable.cpscurl" download target="_blank">
                产品手册
              </a>

              <el-button
                  v-if="isupdate"
                  type="danger"
                  size="small"
                  circle
                  class="delete-btn"
                  style="position:relative"
                  @click="handleRemoveImageCpsc"
              >
                <i class="el-icon-delete"></i>
              </el-button>
            </div>

            <!-- 没图片时显示上传按钮 -->
            <el-upload
                v-if="!selectTable.cpsc && isupdate"
                class="upload-demo"
                action="#"
                :auto-upload="false"
                :show-file-list="false"

                :on-change="handleAvatarChangeCpsc"
            >
              <el-button type="primary" plain size="small">
                <el-icon>
                  <Upload/>
                </el-icon>
                上传产品手册
              </el-button>
              <template #tip>
                <div class="el-upload__tip">
                  不超过 500MB
                </div>
              </template>
            </el-upload>
          </div>

        </el-form-item>
        <el-form-item label="进价:" label-width="100px" v-if="checkPrower('bzcbj')" class="price-management-page"
                      prop="zdlprice">
          <el-input-number
              :disabled="!isupdate"
              v-model="selectTable.purchase"
              :precision="2"
              :step="0.01"
              :min="0"
              :controls="false"
              input-align="left"
              style="width: 100%;"/>
        </el-form-item>
        <el-form-item label="备注:" label-width="100px" prop="remark">
          <el-input v-model="selectTable.remark" auto-complete="off" :disabled="!isupdate"></el-input>
        </el-form-item>
        <el-form-item label="总代理售价:" class="price-management-page" v-if="checkPrower('bzsj')" label-width="100px"
                      prop="zdlprice">
          <el-input-number
              :disabled="!isupdate"
              v-model="selectTable.zdlprice"
              :precision="2"
              :min="0"
              :controls="false"
              style="width: 100%;"
              :class="{'left-text': true}">
          </el-input-number>
        </el-form-item>
        <el-form-item label="一级代理售价:" class="price-management-page" v-if="checkPrower('bzsj')" label-width="100px"
                      prop="ydprice">
          <el-input-number
              :disabled="!isupdate"
              v-model="selectTable.ydprice"
              :precision="2"
              :min="0"
              :controls="false"
              style="width: 100%;"
              :class="{'left-text': true}">
          </el-input-number>
        </el-form-item>
        <el-form-item label="集成商售价:" class="price-management-page" v-if="checkPrower('bzsj')" label-width="100px"
                      prop="jcsprice">
          <el-input-number
              :disabled="!isupdate"
              v-model="selectTable.jcsprice"
              :precision="2"
              :min="0"
              :controls="false"
              style="width: 100%;"
              :class="{'left-text': true}">
          </el-input-number>
        </el-form-item>
        <el-form-item label="终端售价:" class="price-management-page" v-if="checkPrower('bzsj')" label-width="100px"
                      prop="zdprice">
          <el-input-number
              :disabled="!isupdate"
              v-model="selectTable.zdprice"
              :precision="2"
              :min="0"
              :controls="false"
              style="width: 100%;"
              :class="{'left-text': true}">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" v-if="isupdate" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog id="titleid" title="添加标签" :visible.sync="dialogFormVisibleTitle" :close-on-click-modal="false">
      <el-form :model="TitleInfo">
        <el-form-item label="标签:" label-width="100px">
          <el-input v-model="TitleInfo.name" auto-complete="off"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleTitle = false">取 消</el-button>
        <el-button type="primary" @click="createTitle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    // 阈值和单位联合校验
    const validateYzAndDw = (rule, value, callback) => {
      // 检查阈值是否为空（required 已处理，这里做额外检查）
      if (!this.selectTable.yz && this.selectTable.yz !== 0) {
        callback(new Error('阈值不能为空'));
        return;
      }

      // 检查单位是否为空
      if (!this.selectTable.dw) {
        callback(new Error('单位不能为空'));
        return;
      }

      // 阈值必须大于等于1
      if (this.selectTable.yz < 1) {
        callback(new Error('阈值不能小于1'));
        return;
      }

      // 所有校验通过
      callback();
    };
    return {

      formRules: {
        name: [
          {required: true, message: '产品名称不能为空', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '产品编码不能为空', trigger: 'blur'},
          {
            pattern: /^[A-Za-z0-9_/ -]+$/,
            message: '只能包含字母、数字、下划线、中划线和正斜杠',
            trigger: 'blur'
          }
        ],
        isycl: [
          {required: true, message: '请选择是否为原材料', trigger: 'change'}
        ],
        ycode: [
          {
            required: true,
            message: '原材料编码不能为空',
            trigger: 'blur',
            // 条件必填
            validator: (rule, value, callback) => {
              if (this.selectTable.isycl == '1' && !value) {
                callback(new Error('原材料编码不能为空'));
              } else {
                callback();
              }
            }
          }
        ],
        yname: [
          {
            required: true,
            message: '原材料名称不能为空',
            trigger: 'blur',
            // 条件必填
            validator: (rule, value, callback) => {
              if (this.selectTable.isycl == '1' && !value) {
                callback(new Error('原材料名称不能为空'));
              } else {
                callback();
              }
            }
          }
        ],
        yz: [
          {required: true, message: '阈值不能为空', trigger: 'blur'},
          {validator: validateYzAndDw, trigger: 'blur'}
        ],
        dw: [
          {required: true, message: '请选择单位', trigger: 'change'}
        ],
        pp: [
          {required: true, message: '品牌不能为空', trigger: 'blur'},
          {min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur'}
        ],
        cs: [
          {max: 300, message: '参数不能超过300个字符', trigger: 'blur'}
        ],
        remark: [
          {max: 500, message: '备注不能超过500个字符', trigger: 'blur'}
        ]
      },
      multipleSelection: [],
      isupdate: false,
      dialogFormVisibleTitle: false,
      TitleInfo: {
        name: undefined,
        type: 'sp',
        state: '1',
      },
      allTags: [],
      selectedTags: [],
      optionskhlx: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        code: undefined,
        status: 1,
      },
      selectTable: {
        title: '',
        id: 0,
        status: 1,
        name: undefined,
        state: 1,
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      menuOptions: [],
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.getTitle();

  },

  methods: {
    copyText(row) {
      const text = `${row.name}\t${row.code}`;
      if (!text) {
        this.$message.warning('没有可复制的内容');
        return;
      }

      try {
        navigator.clipboard.writeText(text);
        this.$message.success('复制成功：' + text);
      } catch (err) {
        console.error('复制失败:', err);
        // 降级方案
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('复制成功：' + text);
        } else {
          this.$message.error('复制失败，请手动复制');
        }
      } catch (err) {
        this.$message.error('复制失败：' + err.message);
      }

      document.body.removeChild(textarea);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    batchExport() {
      const selectedIds = this.multipleSelection.map(item => item.id);
      console.log('选中的产品ID集合:', selectedIds);

      // 这里可以继续添加实际的导出逻辑，例如调用接口
      // 如果希望至少选中一项才导出，可以加判断
      if (selectedIds.length === 0) {
        this.$message.warning('请至少选择一条产品数据');
        return;
      } else {
        this.$request.postHttp({
          url: "/basic/batchExport",
          data: JSON.stringify({tags: selectedIds}),
          success: (data) => {
            if (data.code == 200) {
              this.$message.success('导出成功正在下载！')
              const link = document.createElement('a');
              link.href = data.msg;
              link.download = '产品列表'; // 设置下载文件名
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              if (this.multipleSelection.length > 0) {
                this.$refs.multipleTable.clearSelection();
              }

            } else {
              this.$message.warning(data.msg)
            }

          },
          error: (error) => {
            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }
    },


// 模拟导出成功提示

    openTitle() {
      this.TitleInfo = this.$options.data().TitleInfo
      this.dialogFormVisibleTitle = true
    },
    deleteTag(tag) {
      this.$request.postHttp({
        url: "/basic/delTitle",
        data: JSON.stringify(tag),
        success: (data) => {
          this.$message.success(data.msg)
          this.dialogFormVisibleTitle = false
          this.getTitle();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    toggleTag(tag) {
      const index = this.selectedTags.findIndex(t => t.name === tag.name)
      if (index === -1) {
        this.selectedTags.push({...tag})
      } else {
        this.selectedTags.splice(index, 1)
      }
    },
    handleAvatarChange(file) {
      if (!this.beforeAvatarUpload(file.raw)) return


      let fd = new FormData();

      //文件信息中raw才是真的文件
      fd.append("file", file.raw);
      //console.log(item.raw)
      this.$request.postHttp(
          {
            url: "/basic/upProPic",
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: fd,
            success: (data) => {
              if (data.code == '500') {
                this.$message.warning(data.msg)
              } else {
                this.selectTable.cppic = data.data.pid
                this.selectTable.cppicurl = data.data.url

              }
            },
            error: (error) => {
              console.error("Error:", error);

              // 执行失败时的操作
            },
          })
    },
    beforeAvatarUpload(file) {
      const isImage = ['image/jpeg', 'image/png',].includes(file.type)
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片！')
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB！')
      }
      return isImage && isLt5M
    },
    handleRemoveImage() {
      this.$confirm('此操作将删除产品照片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectTable.cppic = ''
        this.selectTable.cppicurl = ''
        this.$message.success('已删除')
      })
          .catch(() => {
            // 用户取消，不做操作
          })
    },
    handleAvatarChangeCpsc(file) {
      if (!this.beforeAvatarUploadCpsc(file.raw)) return

      let fd = new FormData();

      //文件信息中raw才是真的文件
      fd.append("file", file.raw);
      //console.log(item.raw)
      this.$request.postHttp(
          {
            url: "/basic/upProCpsc",
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: fd,
            success: (data) => {
              if (data.code == '500') {
                this.$message.warning(data.msg)
              } else {
                this.selectTable.cpsc = data.data.pid
                this.selectTable.cpscurl = data.data.url

              }
            },
            error: (error) => {
              console.error("Error:", error);

              // 执行失败时的操作
            },
          })
    },
    beforeAvatarUploadCpsc(file) {
      const isLt5M = file.size / 1024 / 1024 < 500
      if (!isLt5M) {
        this.$message.error('产品手册大小不能超过 500MB！')
      }
      return isLt5M
    },
    handleRemoveImageCpsc() {
      this.$confirm('此操作将删除产品手册, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectTable.cpsc = ''
        this.selectTable.cpscurl = ''
        this.$message.success('已删除')
      })
          .catch(() => {
            // 用户取消，不做操作
          })
    },
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },
    getRowClass({row}) {
      if (row.state > row.yz) {
        return 'row-green';
      } else {
        return 'row-red';
      }
    },

    createtree() {
      this.$refs.selectForm.validate((valid) => {
        if (valid) {
          this.selectTable.bq = (this.selectedTags.map(tag => tag.id) ?? []).join(',')
          this.$request.postHttp({
            url: "/basic/saveProductInfo",
            data: JSON.stringify(this.selectTable),
            success: (data) => {
              if (data.code == 200) {
                this.$message.success(data.msg)
                this.dialogFormVisible = false
                this.getList();
              } else {
                this.$message.warning(data.msg)
              }

            },
            error: (error) => {
              console.error("Error:", error);
              // 执行失败时的操作
            },
          })
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });


    },
    createTitle() {
      if (this.TitleInfo.name == null) {
        this.$message.warning('请输入标签')
        return
      }
      this.$request.postHttp({
        url: "/basic/addTitle",
        data: JSON.stringify(this.TitleInfo),
        success: (data) => {
          if (data.code == 200) {
            this.$message.success(data.msg)
            this.dialogFormVisibleTitle = false
            this.getTitle();
          } else {
            this.$message.warning(data.msg)
          }


        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/ProductList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    deleterole(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/basic/deletesp",
          params: {rid: row.id},
          success: (data) => {
            this.$message.success('删除成功！')

            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    createdata() {
      this.selectTable = {  title: '添加产品信息',
        id: 0,
        status: 1,
        name: undefined,
        state: 1}
      this.isupdate = true
      this.dialogFormVisible = true;
      if (this.$refs.selectForm) {
        this.$refs.selectForm.clearValidate()
      }

    },
    handleEdit(row, type) {
      this.selectTable.id = row.id
      let user = localStorage.getItem("user");
      this.$request.getHttp({
        url: "/basic/getProductInfo",
        params: {id: this.selectTable.id,user:user},
        success: (data) => {
          if (this.$refs.selectForm) {
            this.$refs.selectForm.clearValidate()
          }
          this.selectTable = data.data

          if (this.selectTable.id == null) {
            this.selectTable.id = 0
          }
          if (this.selectTable.id > 0) {
            this.selectTable.title = '修改产品信息'
          } else {
            this.selectTable.title = '添加产品信息'
          }
          this.dialogFormVisible = true;
          this.getselectTitle();
          if (type == 1) {
            this.isupdate = true
          } else {
            this.isupdate = false
          }
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },
    getTitle() {
      this.$request.postHttp({
        url: "/basic/TitleList",
        params: {pname: 'sp'},
        success: (data) => {
          this.allTags = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getselectTitle() {
      if (!this.selectTable.bq || this.selectTable.bq.trim() === '') {
        this.selectedTags = [];
        return;
      }
      const idArray = this.selectTable.bq.split(',').map(id => parseInt(id, 10));
// 从allTags中筛选出对应的标签
      this.selectedTags = this.allTags.filter(tag => idArray.includes(tag.id));
    }
  },

  computed: {
    selectedNames() {
      return this.selectedTags.map(t => t.name)
    }
  }
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

/* 如果 ::v-deep 不行，试试 /deep/ */
.price-management-page .el-input-number .el-input__inner {
  text-align: left !important;
}

selectupwidth el-select {
  width: 120px;
}

#cdia .el-dialog {
  margin-top: 7vh !important;
}

/* 绿色行 - state > yz */
.el-table .row-green {
  background-color: #f0f9eb !important; /* 浅绿色 */
}

.upload-wrapper {
  position: relative;
}

.preview-box {
  position: relative;
  display: inline-block;
}

.delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 10;
}

.upload-demo {
  display: inline-block;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}

.el-table .row-green:hover > td {
  background-color: #e1f3d8 !important; /* 悬停加深 */
}

/* 红色行 - state <= yz 或 state 为空 */
.el-table .row-red {
  background-color: #fef0f0 !important; /* 浅红色 */
}

.el-table .row-red:hover > td {
  background-color: #fde2e2 !important; /* 悬停加深 */
}

.queryParamsStyle {
  margin-left: 10px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>